<div class="ui-g">
  <div class="ui-g-12 ui-lg-6">
    <h1 class="step-title">{{ (editMode ? 'couponingSystemList.edit_title' : 'couponingSystemList.add_title') | translate }}</h1>
  </div>

  <div class="ui-g-12 ui-lg-6 text-right">
    <button pButton type="button" class="k-generic-btn" icon="fa fa-angle-left" iconPos="left" (click)="goBack()" label="{{ 'common.back' | translate }}"></button>
    <button pButton type="button" class="k-generic-btn" icon="fa fa-floppy-o" iconPos="left" (click)="save()" label="{{ 'common.save' | translate }}"></button>
  </div>

  <div class="clearfix"></div>

  <div class="card Loyalty ui-g" style="width: 40%;">
    <form *ngIf="fields && addEditForm" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="addEditForm" (ngSubmit)="save()" RestrictFocus style="width: 100%;">
      <div class="ui-g ui-g-nopad form-group">
        <div class="ui-g-12 ui-md-6 form-control">
          <span class="label" [ngClass]="{'required': !fields.code.nullable}">{{ 'common.code' | translate }}</span>
          <input formControlName="code" pInputText maxlength="10" />
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.code"></app-validation-msg>
        </div>
        <div class="ui-g-12 ui-md-6 form-control">
          <span class="label" [ngClass]="{'required': !fields.name.nullable}">{{ 'common.name' | translate }}</span>
          <input formControlName="name" pInputText maxlength="255" />
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.name"></app-validation-msg>
        </div>
        <div class="ui-g-12 form-control">
          <span class="label" [ngClass]="{'required': !fields.description.nullable}">{{ 'common.description' | translate }}</span>
          <input formControlName="description" pInputText maxlength="255" />
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.description"></app-validation-msg>
        </div>
        <div class="ui-g-12 ui-md-4 form-control">
          <span class="label">{{ 'common.image' | translate }}</span>
          <input #fileInput type="file" (change)="uploadImg($event.target.files)" accept=".png,.jpg,.jpeg" />
          <p-fileUpload
            #imageDropzone
            name="image"
            multiple="false"
            customUpload="true"
            auto="true"
            accept=".png,.jpg,.jpeg"
            (uploadHandler)="uploadImg($event.files); imageDropzone.clear()">
            <ng-template pTemplate="content">
              <div class="ui-fluid drag" (click)="fileInput.click()">
                <i class="fa fa-upload icon-upload"></i>
                <br>
                <strong class="drag-description">{{ 'common.dragDropImage' | translate }}</strong>
              </div>
            </ng-template>
          </p-fileUpload>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.img_b64"></app-validation-msg>
        </div>
        <div class="ui-g-12 ui-md-4 form-control" *ngIf="hasImage">
          <span class="label">{{ 'cluster_ochannel.preview' | translate }}</span>
          <div id="img-container">
            <img [src]="previewSrc" width="100" alt="anteprima immagine">
            <button
              pButton
              type="button"
              (click)="removeImage()"
              icon="fa fa-times"
              id="remove-img-btn"
              class="ui-button-danger btnDelete">
            </button>
          </div>
        </div>
        <div class="ui-g-12 form-control">
          <span class="label">{{ 'common.imageUrl' | translate }}</span>
          <input type="text" pInputText formControlName="img_url" placeholder="https://..." />
        </div>
      </div>
    </form>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/administration/couponing-system/couponing-systemForm.html